import { Box, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectPermisos } from '../stores/userSlice'

export default function PermisosSelector({ onClose }) {
  const permisos = useSelector(selectPermisos)
  const permisoActual = sessionStorage.getItem('permisoSeleccionado') || '1'

  const handlePermisoClick = (permiso) => {
    // Guardar nuevo permiso en sessionStorage
    sessionStorage.setItem('permisoSeleccionado', permiso.orden.toString())

    // Cerrar el popup
    if (onClose) onClose()

    // Recargar la página para aplicar el cambio
    window.location.reload()
  }

  if (!permisos || permisos.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No hay permisos disponibles
        </Typography>
      </Box>
    )
  }

  if (permisos.length === 1) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Solo tienes un permiso disponible
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ minWidth: 300, maxWidth: 400 }}>
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle2" fontWeight="bold">
          Selecciona una empresa
        </Typography>
      </Box>
      <List>
        {permisos.map((permiso) => {
          const isSelected = permiso.orden.toString() === permisoActual
          return (
            <ListItem key={permiso.orden} disablePadding>
              <ListItemButton selected={isSelected} onClick={() => handlePermisoClick(permiso)}>
                <ListItemText
                  primary={
                    permiso.d_rh_centro || permiso.d_rh_subempresa || `Permiso ${permiso.orden}`
                  }
                  secondary={permiso.d_rh_subempresa || ''}
                  primaryTypographyProps={{
                    fontWeight: isSelected ? 'bold' : 'normal',
                  }}
                />
              </ListItemButton>
            </ListItem>
          )
        })}
      </List>
    </Box>
  )
}
